import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router-dom';
import compose from 'recompose/compose';

import { addLayer } from '../../../actions';
import {
  getDefaultCoreSpec,
  getDefaultPrepregSpec,
  getDefaultInnerCopperSpec,
  getStackupLayers,
  getStackupType,
  getLengthUnit,
} from '../../../reducers';
import AddLayerComponent from './AddLayerComponent';
import { saveStackup } from '../../../services/stackup';
import propTypes from './propTypes';

function mapStateToProps(state){
  return {
    core:          getDefaultCoreSpec(state),
    copper:        getDefaultInnerCopperSpec(state),
    prepreg:       getDefaultPrepregSpec(state),
    stackupLayers: getStackupLayers(state),
    stackupType:   getStackupType(state),
    lengthUnit:    getLengthUnit(state),
  }
}

const mapDispatchToProps = {
  addLayer
}

export class AddLayerContainer extends Component {
  constructor(prop) {
    super(prop);
    this.onClose = this.onClose.bind(this);
  }

  onClose(spec){
    const { addLayer, history } = this.props;

    if (spec !== undefined){
      addLayer(spec);
      saveStackup();
    }
    history.push('/app');
  }

  render () {
    const { stackupLayers } = this.props;

    return stackupLayers.length === 0
      ? <Redirect to={{ pathname: '/app/new' }} />
      : <AddLayerComponent {...this.props} onClose={this.onClose} />;
  }
}

AddLayerContainer.propTypes = propTypes;

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(AddLayerContainer);



// WEBPACK FOOTER //
// ./src/components/StackupDesign/AddLayer/AddLayerContainer.js